import { Box, SxProps, Typography } from "@mui/material";

/*
 * The title and description shown above a field.
 * Adds an asterisk if the field is required.
 */
export const FieldLabel = ({
  title,
  description,
  required = false,
  sx,
}: {
  title?: string;
  description?: string;
  required?: boolean;
  sx?: SxProps;
}) => {
  if (!title && !description) return null;

  return (
    <Box sx={sx}>
      {title && (
        <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
          {title}
          {required && (
            <Typography component="span" color="error" sx={{ ml: 0.5 }}>
              *
            </Typography>
          )}
        </Typography>
      )}

      {description && (
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ mb: 0.5, display: "block" }}
        >
          {description}
        </Typography>
      )}
    </Box>
  );
};
